(function() {
    var BackButton = function ($el) {
        this.$el = $el

        $el.on('click', this.revertHistory)

        return this
    }

    BackButton.prototype.revertHistory = function (event) {
        event.preventDefault()
        window.history.back()

        return this
    }

    $('.back-button').each(function () {
        new BackButton($(this))
    });

    $('.datatable').on('draw.dt', function() {
        setTimeout(function(){
            var url = new URL(window.location);
            if(url.searchParams.get('expand')){
                if(url.searchParams.get('expand').indexOf(',') > -1){
                    $.each(url.searchParams.get('expand').split(','), function(key, value){
                        $('[data-id="' + value + '"]').trigger('click');
                    });
                }
                else{
                    $('[data-id="' + url.searchParams.get('expand') + '"]').trigger('click');
                }
            }
        }, 500);
    });
})()
